import { render } from "./PageTitle.vue?vue&type=template&id=64a9d246"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=64a9d246&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__